import { Button, Collapse } from "reactstrap";
import { useState } from "react";

import { uppyPlugins } from "../../Inputs/ExcelCSVInput";
import { FileSelectedInfo } from "../ImportCSVDrawer";
import TenantAPI from "../../../api/api/TenantAPI";
import AppAlert from "../../../elements/AppAlert";
import UppyFile from "../../Inputs/UppyFile";

interface Props {
  file: any;
  setFile: any;
  fileRecordID: string;
  setFileRecordID: (recordID: string) => void;
  fileSelectionOpen: boolean;
  setFileSelectionOpen: (newBool: boolean) => void;
  startProcessing: () => void;
}

export default function FileSelectionPage({
  file,
  setFile,
  fileRecordID,
  setFileRecordID,
  fileSelectionOpen,
  setFileSelectionOpen,
  startProcessing,
}: Props) {
  const [showAlert, setShowAlert] = useState(true);

  return (
    <>
      <Collapse isOpen={fileSelectionOpen}>
        {showAlert && (
          <AppAlert>
            This feature is built for CSV / Excel files that aren't GrowthCloud
            exports.
            <br />
            <br />
            If you want to copy a data source from another GrowthCloud, download
            the data source as json in the settings, and use the "Create From
            JSON" option from the last step.
          </AppAlert>
        )}
        <div className="tw:flex tw:justify-center">
          <UppyFile
            fileType="Data"
            plugins={uppyPlugins}
            width={300}
            afterSubmit={(res) => {
              setFile(res);
              setFileRecordID(
                // @ts-ignore
                res.RecordID || ""
              );
              setFileSelectionOpen(false);
            }}
            doneButtonHandler={() => setFileSelectionOpen(false)}
            multiFiles={false}
            filesToFilter={file ? (Array.isArray(file) ? file : [file]) : []}
          />
        </div>
      </Collapse>
      {file && !fileSelectionOpen && (
        <FileSelectedInfo
          file={file}
          onChange={() => {
            TenantAPI.deleteFiles({
              type: "fileID",
              fileID: fileRecordID,
              moduleAPIName: "",
              fieldAPIName: "",
              recordID: "",
            });
            setFileSelectionOpen(true);
            setFileRecordID("");
            setFile(null);
          }}
        />
      )}
      {file && (
        <ul
          className="bg-superlight rounded border p-3 mt-4"
          style={{
            listStyle: "none",
            display: "grid",
            gap: 15,
            fontWeight: 500,
            color: "var(--dark)",
          }}
        >
          <li>
            We'll attempt to create your data source based on the data in your
            CSV file
          </li>
          <li>
            Then we'll provide you with an overview of the data source before
            it's created, so you can finalize it's configuration
          </li>
          <li>
            You can then proceed with uploading the data in the file if you
            desire.
          </li>
          <li>You may cancel this process at any time.</li>
          <li>
            Press{" "}
            <Button
              color="primary"
              size="sm"
              className="tw:mx-1"
              onClick={startProcessing}
            >
              Next
            </Button>{" "}
            at the top of this Drawer to continue &#128512;
          </li>
        </ul>
      )}
    </>
  );
}
